import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let LoaderComp;

class Loader extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: LoaderComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/loader-comp" */
            "../../../components/javascript/zcat-components/loader-comp"
        ).then(function(res) {
            LoaderComp = res.LoaderComp;
        }));

        
;
    }
}

export {Loader};

